module.exports = __webpack_public_path__ + "img/fuzhi.7381c6d6.svg";